import React from 'react';
import ExpenseList from './ExpenseList';
import ExpenseListFilter from './ExpenseListFilter';
import ExpenseSummary from './ExpenseSummary';
import Fab from '@mui/material/Fab';
import AddIcon from '@mui/icons-material/Add';
import { orange } from '@mui/material/colors';
import { useNavigate } from 'react-router-dom';

const ExpenseDashBoardPage = () => {

    const navigate=useNavigate();
    const primary=orange[800];

    return (
        <div className='col-md-9 col-12 offset-md-3 expense-dashboard'>
            <h1 className='heading'>My Expenses</h1>
            <hr />

            <ExpenseSummary />
            <ExpenseListFilter />
            <ExpenseList />

            <Fab
                className='add-button'
                style={{
                    backgroundColor:primary
                }}
                aria-label="add"
                onClick={()=>{
                    navigate('/add');
                }}
            >
                <AddIcon />
            </Fab>
        </div>
    );
}

export default ExpenseDashBoardPage;